var $ce40f46d09034645$exports = {};
$ce40f46d09034645$exports = {
  "rangeOverflow": args => `V\u{113}rt\u{12B}bai ir j\u{101}b\u{16B}t ${args.maxValue} vai agr\u{101}kai.`,
  "rangeReversed": `S\u{101}kuma datumam ir j\u{101}b\u{16B}t pirms beigu datuma.`,
  "rangeUnderflow": args => `V\u{113}rt\u{12B}bai ir j\u{101}b\u{16B}t ${args.minValue} vai v\u{113}l\u{101}kai.`,
  "unavailableDate": `Atlas\u{12B}tais datums nav pieejams.`
};
export { $ce40f46d09034645$exports as default };